import { createReducer } from 'reduxsauce';
import { Types } from './actions';

export const initialState = [];

const setFlow = (state, { flow }) => flow;

/* ------------- Hookup Reducers To Types ------------- */
export default createReducer(initialState, { [Types.SET_FLOW]: setFlow });
